import httpClient from "./httpClient";

export default {
  // Vendors
  async getVendors() {
    const response = await httpClient.get(`/vendors`);
    return response.data;
  },

  async deleteVendor(vendorId) {
    const response = await httpClient.delete(`/vendors/${vendorId}`);
    return response.data;
  },

  async createVendor(vendor) {
    const response = await httpClient.post(`/vendors`, {
      ...vendor
    });
    return response.data;
  },

  async updateVendor(vendor) {
    const response = await httpClient.put(`/vendors/${vendor.id}`, {
      ...vendor
    });
    return response.data;
  }
};
